export const pathnames = Object.freeze({
  main: '/',
  'personal-cabinet': '/personal-cabinet',
  apply: '/apply',
  'otp-verify': '/verify',
  biometry: '/biometry',
  'card-type': 'card-type',
  'offline-otp': '/offline-otp',
  'offline-success': '/offline-success',
  delivery: 'delivery',
  success: '/success',
  error: '/error',
  'buy-card': 'buy-card',
  statement: 'statement',
  pending: 'pending',
  'activation-enter-phone': '/activation-enter-phone',
  'mega-activation': '/mega-activation',
  'idn-enter': '/idn-enter',
  'activation-loading': '/activation-loading'
})

export const nr_steps = [
  {
    path: [pathnames.apply],
    title: 'Заявка'
  },
  {
    path: [pathnames['otp-verify']],
    title: 'Подтверждение'
  },
  {
    path: [pathnames.biometry],
    title: 'Биометрия'
  },
  {
    path: [pathnames['card-type']],
    title: 'Выбор карты'
  },
  {
    path: [pathnames.delivery],
    title: 'Доставка'
  },
  {
    path: [pathnames.success],
    title: 'Готово!'
  }
]
